import { render, staticRenderFns } from "./modalInput.vue?vue&type=template&id=3152a060&scoped=true"
import script from "./modalInput.vue?vue&type=script&lang=js"
export * from "./modalInput.vue?vue&type=script&lang=js"
import style0 from "./modalInput.vue?vue&type=style&index=0&id=3152a060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3152a060",
  null
  
)

export default component.exports